<script setup lang="ts">
import Checkbox from 'primevue/checkbox'
import { useId } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Label text; the default slot overrides it (links inside a label, e.g. the registration terms). */
    label?: string
    invalid?: boolean
    disabled?: boolean
    id?: string
    name?: string
    /** Accessible name when there is no visible label (a table's row checkbox). */
    ariaLabel?: string
  }>(),
  { label: '', invalid: false, disabled: false, id: undefined, name: undefined, ariaLabel: undefined },
)

const model = defineModel<boolean | null | undefined>({ default: false })
const emit = defineEmits<{ blur: [event?: Event] }>()
const inputId = props.id || `checkbox-${useId()}`
</script>

<template>
  <div class="app-checkbox inline-flex items-center gap-2" data-kit="checkbox">
    <Checkbox
      :model-value="Boolean(model)"
      binary
      :input-id="inputId"
      :name="name"
      :invalid="invalid"
      :disabled="disabled"
      :aria-label="ariaLabel"
      @update:model-value="(value: boolean) => (model = value)"
      @blur="emit('blur', $event)"
    />
    <label v-if="label || $slots.default" :for="inputId" class="cursor-pointer select-none">
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>
